import Login from '@/views/Login'
import Katalog from '@/views/Katalog'
import Search from '@/views/Search'
import Favorites from '@/views/Favorites'
import Detail from '@/views/Detail'
import Contact from '@/views/Contact'
import Menu from '@/views/Menu'

import homeIcon from '@/img/tabbar/home.svg';
import homeIconActive from '@/img/tabbar/home_active.svg';
import searchIcon from '@/img/tabbar/search.svg';
import searchIconActive from '@/img/tabbar/search_active.svg';
import favoritesIcon from '@/img/tabbar/favorites.svg';
import favoritesIconActive from '@/img/tabbar/favorites_active.svg';
import contactIcon from '@/img/tabbar/contact.svg';
import contactIconActive from '@/img/tabbar/contact_active.svg';

export const bottomNavRoutes = [
	{
		path: '/home',
		name: 'Home',
		icon: homeIcon,
		icon_active: homeIconActive,
		component: Katalog,
    meta: { requiresAuth: true }
	},
	{
		path: '/search',
		name: 'Suche',
		icon: searchIcon,
		icon_active: searchIconActive,
		component: Search,
    meta: { requiresAuth: true }
	},
	{
		path: '/favorites',
		name: 'Favoriten',
		icon: favoritesIcon,
		icon_active: favoritesIconActive,
		component: Favorites,
    meta: { requiresAuth: true }
	},
	{
		path: '/contact',
		name: 'Kontakt',
		icon: contactIcon,
		icon_active: contactIconActive,
		component: Contact,
    meta: { requiresAuth: true }
	},
];

export default {
	routes: [
		{
			path: '/',
			name: 'Login',
			component: Login,
      meta: { requiresAuth: false }
		},
		{
			path: '/detail/:id',
			name: 'Detail',
			component: Detail,
      meta: { requiresAuth: true }
		},
		{
			path: '/menu',
			name: 'Menu',
			component: Menu,
      meta: { requiresAuth: true }
		},
		...bottomNavRoutes,
    {
      path: '*',
      redirect: {
        name: 'Home',
      },
      meta: { requiresAuth: false }
    }
	]
}
